import { render, staticRenderFns } from "./Preorders.vue?vue&type=template&id=030c9862&scoped=true&"
import script from "./Preorders.vue?vue&type=script&lang=js&"
export * from "./Preorders.vue?vue&type=script&lang=js&"
import style0 from "./Preorders.vue?vue&type=style&index=0&id=030c9862&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030c9862",
  null
  
)

export default component.exports